import { createFileRoute } from '@tanstack/react-router';
import { withModalOutlet } from '../-withModalOutlet';
import Users from '../../../administration/src/components/Apps/AppDetails/Permissions/Users';

export const Route = createFileRoute('/_secured/administration/apps/$appId/permissions/users/$page/$limit')({
  component: withModalOutlet(Users),
});
